import MazInput from "./_main.vue";

MazInput.install = (Vue) => {
  Vue.component(MazInput.name, MazInput);
};

export default MazInput;
